module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.18.1@axios/index.js
// module id = 61
// module chunks = 0